import { useQuery } from '@tanstack/react-query';
import { sessionMe } from '@/api/resources';

/**
 * `enabled: false` on the token-gated public screens. A logged-out reviewer
 * 401s here by definition, which is noise in the logs and — until
 * `clearPrivateQueryCache` learned to spare public queries — actively broke the
 * page it was rendered beside.
 */
export function useMe(options?: { enabled?: boolean }) {
  return useQuery(sessionMe(undefined, { enabled: options?.enabled ?? true }));
}
